import React, { Component } from 'react';
import { isEmpty, size } from "lodash";
import { 
    IconButton,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableFooter,
    TablePagination,
    Button,
    Box,
    Card,
    CardContent,
    Grid,
    Tooltip,
    Menu,
    MenuItem,
} from '@mui/material';
import Pagination from '../../../container/MUI/Pagination';
import FactureForm from './FactureForm';
import { Edit, AddCircle, Refresh, CloudDownloadRounded, EditRounded, DeleteRounded, CheckCircleRounded, FileCopyRounded, MoreVertRounded, CheckCircleOutlineRounded, FilterListRounded, ListAltRounded, DonutLargeOutlined } from '@mui/icons-material';
import { InputSelectMulti, InputSelectNative } from '../../common/Form';
import { MONTHS } from '../../../utils/generalFuncs';
import DeleteDialog from '../../common/DeleteDialog';
import Currency from '../../common/Currency';
// import FacturePayments from './FacturePayments';
import FactureStats from './FactureStats';
import IncomeForm from '../Incomes/IncomeForm';
import PostSingle from '../Incomes/PostSingle';
import FacturePaymentForm from '../Incomes/FacturePaymentForm';
import Template1 from './Templates/Template1';
// import FactureDetails from './FactureDetails';

class FacturesList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 15,
        openDetails: false,
        openForm: false,
        openDetails: false,
        openBank: false,
        selected: {},
        selectedPost: {},
        selectedBank: {},
        searchPayMode: "",
        searchMonth: "",
        searchYear: "",
        searchBank: {value: "", label: ""},
        searchPost: {value: "", label: ""},
        showFilters: false,
        anchorEl: null, 
        openMenu: "", 
        view: "list"
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    componentWillMount() {
        window.scrollTo(0, 0);
    }
    componentDidMount = () => {
        if(isEmpty(this.props.FACTURES)){
            this.props.fetchFactures()
        }    
        if(isEmpty(this.props.POSTS)){
            this.props.fetchPosts()
        } 
    }

    handleChange = (e) => {
        const { name, value } = e.target;

        this.setState({
            [name]: value,
            page: 0,
        })
    
    }
    handleSelect = (option, field) => {
        if(option){
            this.setState({                
                [field]: option,
                page: 0,
            })
        } else {
            this.setState({
                searchEmployee: {label: "", value: ""},
                page: 0,
            })

        }
    }
    filterList = () => {
        const { searchBank, searchPost, searchYear, searchMonth, searchPayMode} = this.state;
        const { FACTURES } = this.props
        
        let filteredList = Object.values(FACTURES)
        if( !isEmpty(searchPayMode)) {
            filteredList = filteredList.filter( item => item.facture_payment_mode === searchPayMode)
        }
         
        // if( !isEmpty(searchBank.value)) {
        //     filteredList = filteredList.filter( item => item.facture_bank === searchBank.value)
        // }
        // if( Array.isArray(searchBank) && !isEmpty(searchBank) ) {
        //     let itemList = searchBank.map(item => item.value )
        //     filteredList = filteredList.filter( item => itemList.includes(item.facture_bank))
        // }
        // if( !isEmpty(searchPost.value)) {
        //     filteredList = filteredList.filter( item => item.facture_post === searchPost.value)
        // }
        // if( Array.isArray(searchPost) && !isEmpty(searchPost) ) {
        //     let itemList = searchPost.map(item => item.value )
        //     filteredList = filteredList.filter( item => itemList.includes(item.facture_post))
        // }

        if( !isEmpty(searchMonth.value) ) {
            filteredList = filteredList.filter( item => new Date(item.facture_date).getMonth() == searchMonth)
        } else if( Array.isArray(searchMonth) && !isEmpty(searchMonth)) {
            let itemList = searchMonth.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(new Date(item.facture_date).getMonth()))
        } 

        if( searchYear ) {
            filteredList = filteredList.filter( item => new Date(item.facture_date).getFullYear() == searchYear)
        }
        if( Array.isArray(searchYear) ) {
            let itemList = searchYear.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(new Date(item.facture_date).getFullYear()))
        } 

        return filteredList
    }
    displayList = () => {
        const { FACTURES, POSTS, BANKS } = this.props;
        let tab = []
        let rows = 0

        if (!isEmpty(FACTURES) ){
            let filteredList = this.filterList()
            rows = size(filteredList)
            console.log({filteredList});
            tab.push( this.getFactureList(filteredList))
        }
        return [tab, rows]
    }
    getFactureList = (list) => {
        // const { BANKS, POSTS } = this.props
        const { rowsPerPage, page, openMenu, anchorEl } = this.state;

            return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => {
                return (
                    <TableRow hover key={item.facture_id} className="clickable"
                        // onClick={() => this.setState({ openDetails: true, selected: item })}    
                        // title="Voir le Détail"
                    >
                        <TableCell>
                            {item.facture_fully_paid && <CheckCircleOutlineRounded color="primary" />}
                        </TableCell>
                        <TableCell>{new Date(item.facture_date).toLocaleDateString('fr-FR')}</TableCell>
                        <TableCell>
                            {item.facture_desc}
                        </TableCell>
                        {/* <TableCell 
                            onClick={() => this.setState({openPost: true, selectedPost: (item.facture_post && POSTS[item.facture_post]) }) }
                            className="a-like"
                        >
                            {item.facture_post && POSTS[item.facture_post].post_name}
                        </TableCell> 
                        <TableCell
                            onClick={() => this.setState({openBank: true, selectedBank: (item.facture_bank && BANKS[item.facture_bank]) }) }
                            className="a-like"
                        >
                            {item.facture_bank && BANKS[item.facture_bank].bank_name}
                        </TableCell> */}
                        <TableCell><Currency value={item.facture_amount} /></TableCell>
                        <TableCell><Currency value={item.facture_rest_to_pay} /></TableCell>
                        {/* <TableCell>
                            <Tooltip title="Copier l'ID Facture" placement="left">
                                <IconButton 
                                    onClick={() => {
                                        navigator.clipboard.writeText(item.facture_id); 
                                        this.setState({ copied : item.facture_id })
                                    }} 
                                    color="secondary"
                                >
                                    {this.state.copied === item.facture_id ? <CheckCircleRounded /> : <FileCopyRounded />}
                                </IconButton>
                            </Tooltip>
                        </TableCell>       */}
                        {/* <TableCell onClick={ () => this.setState({openUpdate: true, selected: item}) }>
                            <IconButton 
                                size="small" 
                                color="secondary"
                            >
                                <EditRounded />
                            </IconButton> 
                        </TableCell>      
                        <TableCell onClick={ () => this.setState({openDelete: true, selected: item}) }>
                            <IconButton 
                                size="small" 
                                color="secondary"
                            >
                                <DeleteRounded color="error"/>
                            </IconButton> 
                        </TableCell>       */}
                        <TableCell>
                            <IconButton 
                                aria-controls={`option-menu${item.facture_id}`} 
                                aria-haspopup="true"
                                onClick={(event) => this.setState({ anchorEl: event.currentTarget, openMenu : item.facture_id}) }>
                                <MoreVertRounded />
                            </IconButton>

                            <Menu
                                id={`option-menu${item.facture_id}`}
                                anchorEl={anchorEl}
                                getContentAnchorEl={null}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={ openMenu === item.facture_id}
                                onClose={() => this.setState({ openMenu: "", anchorEl: null})}
                            >
                                {/* { item.facture_amount !== item.facture_total_available &&
                                    <MenuItem 
                                        onClick={ 
                                            () => this.setState({
                                                openDetails: true,
                                                selected: item,
                                                openMenu: "", 
                                                anchorEl:null 
                                            }) 
                                        } 
                                    >
                                        Paiements Liés
                                    </MenuItem>
                                } */}
                                <MenuItem 
                                    onClick={ 
                                        () => this.setState({
                                            openUpdate: true,
                                            selected: item,
                                            openMenu: "", 
                                            anchorEl:null 
                                        }) 
                                    } 
                                >
                                    Modifier
                                </MenuItem>
                                <MenuItem 
                                    onClick={ 
                                        () => this.setState({
                                            openPayment: true,
                                            selected: item,
                                            openMenu: "", 
                                            anchorEl:null 
                                        }) 
                                    } 
                                >
                                    Paiement
                                </MenuItem>
                                <MenuItem 
                                    onClick={ 
                                        () => this.setState({
                                            openDelete: true,
                                            selected: item,
                                            openMenu: "", 
                                            anchorEl:null 
                                        }) 
                                    } 
                                >
                                    Supprimer
                                </MenuItem>
                            </Menu>
                        </TableCell>      
                    </TableRow>
                )
            })
    }

    handleClose = () => {
		this.setState({ 
            openDetails: false,
            openUpdate: false,
            openDelete: false,
            openPayment: false,
            openPost: false,
            openBank: false,
            openForm: false,
            selected: {},
            selectedPost: {},
            selectedBank: {},
        });
    };    
    handleDelete = async () => {
        const { selected } = this.state;
        await this.props.deleteFacture(selected)
        if(this.props.STATE.factures.error){
            this.props.notif("error", this.props.STATE.factures.error)
        } else {
            this.props.notif("success", "Paiement supprimé")
            this.setState({
                openDelete: false,
                selected: {},
            })
        }
    }
    render() {
        const { FACTURES, BANKS, POSTS } = this.props;
        const { rowsPerPage, page, openForm, openDetails, selected, openDelete, openUpdate, openPost, selectedPost, openPayment, selectedBank, showFilters, view } = this.state;
        let YEARS = []
        for (let year = 2019; year <= new Date().getFullYear(); year++) {
            YEARS.push(year)
        }
        console.log('==== STATE FACTURE LIST ================================');
        console.log(this.state);
        console.log('====================================');
        let list = this.displayList()
        return (
            <div>
                {openForm &&
                    <FactureForm open={openForm} handleClose={this.handleClose} {...this.props} />
                }
                {/* {openDetails && !isEmpty(selected) && 
                    <FacturePayments open={openDetails} handleClose={this.handleClose} {...this.props} facture={selected} />
                } */}
                {openUpdate && !isEmpty(selected) &&
                    <FactureForm 
                        update 
                        facture={selected} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
                {openPayment && !isEmpty(selected) &&
                    <FacturePaymentForm 
                        open={true} 
                        handleClose={this.handleClose} 
                        facture={selected}
                        {...this.props} 
                    />
                }
                {openPost && !isEmpty(selectedPost) &&
                    <PostSingle 
                        post={selectedPost} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                        budget_year={this.state.searchYear}
                    />
                }
                {/* {openBank && !isEmpty(selectedBank) &&
                    <BankSingle 
                        bank={selectedBank} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                        budget_year={this.state.searchYear}
                        facture
                    />
                } */}
                {openDelete && !isEmpty(selected) &&
                    <DeleteDialog
                        title={"le Paiement"}
                        close={this.handleClose}
                        notif={this.props.notif}
                        handleSubmit={this.handleDelete}
                        disabledSubmit={this.props.STATE.factures.fetching}
                    >
                        Paiement du {new Date(selected.facture_date).toLocaleDateString("fr-FR")} - Montant: <Currency value={selected.facture_amount} />
                    </DeleteDialog>
                }
                
                <Box
                    style={{textAlign: "right"}}
                >

                {/* <Button
                    color="primary"
                    startIcon={view === "stats" ? <ListAltRounded /> : <DonutLargeOutlined />}
                    onClick={() => this.setState({view: view === "stats" ? "list" : "stats"})}
                >
                    {`${view !== "stats" ? "Stats": "Liste"}`}
                </Button> */}
                </Box>
                {view === "stats" ?
                    // <FactureStats 
                    //     {...this.props}
                    //     {...this.state}
                    // />
                    <Template1 />
                :
                    <Box>

                        <Typography variant="h6" id="tableTitle">
                            Liste des Factures
                        </Typography>

                        <Box style={{display: "flex", justifyContent:"space-between"}}>
                            <Box>
                                <Button color="secondary" 
                                    onClick={() => this.setState({ showFilters: !showFilters })} 
                                    title="Afficher les filtres"
                                    startIcon={<FilterListRounded />}
                                >
                                    Filtres
                                </Button>
                            </Box>

                            <Box style={{textAlign: "right"}}>
                                <Button variant="contained" color="secondary" 
                                    onClick={() => this.setState({ openForm: true })} 
                                    title="Nouvelle Facture"
                                    startIcon={<AddCircle />}
                                >                            
                                    Créer
                                </Button>
                                {/* {this.props.isSuper &&
                                    <IconButton color="primary" onClick={this.props.recalcFactures}>
                                        <Refresh />
                                    </IconButton>
                                } */}
                                <IconButton color="primary" onClick={() => this.props.openFormDownload("/extract/factures")} title="Télécharger" disabled={this.props.downloading}>
                                    <CloudDownloadRounded />
                                </IconButton>
                            </Box>
                        </Box>
                        {showFilters &&
                            <Card>
                            <CardContent>
                                <Grid container>
                                    <Grid item xs={6}>
                                        <InputSelectMulti
                                            label="Mois"
                                            name="searchMonth"
                                            onChange={(option) => this.handleSelect(option, "searchMonth")}
                                            value={this.state.searchMonth}
                                            id="searchMonth"
                                            options={MONTHS.map( (month, index) => ({
                                                label: month,
                                                value: index,
                                                disabled: Array.isArray(this.state.searchMonth) && !!this.state.searchMonth.find(element => element.value === index)
                                                
                                            })) }
                                            isMulti
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <InputSelectNative
                                            label="Année"
                                            name="searchYear"
                                            onChange={this.handleChange}
                                            value={this.state.searchYear}
                                            labelWidth={70} 
                                            id="searchYear"
                                            options={YEARS.map( year => (
                                                <option value={year} key={year}>
                                                    {year}
                                                </option>
                                            )) }
                                        />
                                    </Grid>
                                    
                                    {/* {!isEmpty(BANKS) && 
                                        <Grid item xs={6}>
                                            <InputSelectMulti
                                                label="Banque"
                                                id="searchPost"
                                                options={Object.values(BANKS).map( item => ({
                                                    label: `${item.bank_name}`,
                                                    value: item.bank_id,
                                                    disabled: Array.isArray(this.state.searchBank) && !!this.state.searchBank.find(element => element.value === item.bank_id)
                                                    
                                                }))}
                                                value={this.state.searchBank}
                                                onChange={(option) => this.handleSelect(option, "searchBank")}
                                                isMulti
                                            />
                                        </Grid>
                                    }
                                    {!isEmpty(POSTS) && 
                                        <Grid item xs={6}>
                                            <InputSelectMulti
                                                label="Poste"
                                                id="searchPost"
                                                options={Object.values(POSTS).map( item => ({
                                                    label: `${item.post_name}`,
                                                    value: item.post_id,
                                                    disabled: Array.isArray(this.state.searchPost) && !!this.state.searchPost.find(element => element.value === item.post_id)
                                                    
                                                }))}
                                                value={this.state.searchPost}
                                                onChange={(option) => this.handleSelect(option, "searchPost")}
                                                isMulti
                                            />
                                        </Grid>
                                    } */}

                                    {/* <Grid item xs={12} sm={6} >
                                        <InputSelectNative
                                            label="Mode de Paiement"
                                            name="searchPayMode"
                                            onChange={this.handleChange}
                                            value={this.state.searchPayMode}
                                            labelWidth={150} 
                                            options={[
                                                <option value="ESPECES">ESPECES</option>,
                                                <option value="CHEQUE">CHEQUE</option>,
                                                <option value="PRELEVEMENT">PRELEVEMENT</option>,
                                                <option value="VIREMENT">VIREMENT</option>,
                                                <option value="GAB">GAB</option>,
                                                <option value="MOBILE MONEY">MOBILE MONEY</option>,
                                                <option value="COLLAB">COLLAB</option>,
                                            ]}
                                        />
                                    </Grid> */}
                                </Grid>
                            </CardContent>
                            </Card>
                        }
                        
                        {!isEmpty(FACTURES) && 
                            <div className="table-responsive">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Validé</TableCell>
                                            <TableCell>Créé le</TableCell>
                                            <TableCell>Description</TableCell>
                                            {/* <TableCell>Poste</TableCell>
                                            <TableCell>Banque</TableCell> */}
                                            <TableCell>Montant</TableCell>
                                            <TableCell>Reste à Payer</TableCell>
                                            {/* <TableCell>Copier ID</TableCell> */}
                                            <TableCell>Options</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {list[0]}
                                    </TableBody>
                                    <TableFooter>
                                        <TableRow>
                                            <TablePagination
                                                rowsPerPageOptions={[20, 30]}
                                                labelRowsPerPage="Lignes par Page"
                                                colSpan={9}
                                                count={list[1]}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                SelectProps={{
                                                    native: true,
                                                }}
                                                onPageChange={this.handleChangePage}
                                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                                                ActionsComponent={Pagination}
                                            />
                                        </TableRow>
                                    </TableFooter>
                                </Table> 
                            </div>
                        }
                    </Box>
                }
            </div>
        );
    }
}

export default FacturesList;